import { render, staticRenderFns } from "./LoginSocial.vue?vue&type=template&id=023282da&scoped=true"
import script from "./LoginSocial.vue?vue&type=script&lang=js"
export * from "./LoginSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023282da",
  null
  
)

export default component.exports